import { render, staticRenderFns } from "./editRich.vue?vue&type=template&id=5d8a9cc4&scoped=true&"
import script from "./editRich.vue?vue&type=script&lang=js&"
export * from "./editRich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a9cc4",
  null
  
)

export default component.exports